<template>
    <div
        class="section flex_child_2_2 md_content_1"
        style="min-width: 420px; margin-right:10px;"
    >
        <div class="section_wrap row">
          <h6 class="--blue70 mb20">{{ $t('details') }}</h6>
            <div class="reh_con_scroll custom" style="overflow: auto;">
                <KvTable :items="showFixedRehabilitationDetails" :custom="true"/>
                <KvTable :items="showRehabilitationDetails" :custom="true"/>
            </div>
        </div>
    </div>
</template>
<script>
  import KvTable from '@/components/Table/kvTable';
  import {showFixedRehabilitationDetails} from './index'
  import { showRehabilitationDetails } from "@/components/modal/detailsAndRecord/details/index";

  export default {
    props: ['selectedExerciseProps'],
    components: {
      KvTable
    },
    data() {
      return {}
    },
    methods: {},
    computed: {
      showFixedRehabilitationDetails() {
        return showFixedRehabilitationDetails(this);
      },

      showRehabilitationDetails() {
        return showRehabilitationDetails(this);
      }
    }
  }
</script>
<style lang="scss">
.rehab_memo {
  margin-top: 20px !important;
  height: 100% !important;

  .item-title {
    max-width: 85px;
  }

  .item-value {
    word-break: break-word;
  }
}

.custom-title {
  overflow: auto;
  max-height: 45px;

  span {
    line-height: 20px;
    vertical-align: middle;
  }
}

.custom-memo {
  height: 100%;
  overflow: hidden;
}

.custom {
  .table-container {
    .item-parent {
      .item-title {
        //background-color: #f7f7f7;
        min-height: 45px;
        height: 100%;
        width: 100%;
        display: table;
        border-radius:10px;

        span {
          padding-left: 5px;
          padding-right: 5px;
          display: table-cell;
          //text-align: center;
          vertical-align: middle;
        }
      }

      :nth-child(2) {
        padding-left: 5px;
        padding-right: 5px;
      }
    }
  }
}
</style>